/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementListLivecarpForSelectResponse } from './LiveManagementListLivecarpForSelectResponse';

export type LiveManagementListLivecarpForSelectResponseApiRespoonse = {
    data?: LiveManagementListLivecarpForSelectResponse;
    status?: LiveManagementListLivecarpForSelectResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementListLivecarpForSelectResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

